module.exports = __webpack_public_path__ + "img/ring_skip_0_null_null.7b9d76a2.png";